import axios from "axios";
import Swal from 'sweetalert2';
import { v4 as uuidv4 } from 'uuid';
import isEmail from "validator/lib/isEmail";
import freeDomains from "free-email-domains";
import disposableDomains from "disposable-email-domains";

const API_BASE = process.env.REACT_APP_API_URL;

export const generateVisitorId = () => {
  const visitorId = uuidv4();
  localStorage.setItem('visitorId', visitorId);
  return visitorId;
};

export const introPrompt = "Hi, I am Kumar. An AI Business Analyst. I want to help you define the scope of the application you want to develop for your business.";
export const initSystemPrompt = "Briefly describe the application you want to develop: e.g. which industry do you work in, which processes do you want to transform and why?";

export function getInitials(value = "") {
  return String(value)
    .trim()
    .replace(/[^\p{L}\p{N}\s'-]+/gu, "")
    .split(/[\s-]+/u)
    .filter(Boolean)
    .map(w => {
      const m = w.match(/[\p{L}\p{N}]/u);
      return m ? m[0].toUpperCase() : "";
    })
    .join("");
}

export function getDomain(email) {
  const emailParts = email.split('@');
  const emailDomainParts = emailParts[1].split('.');
  const subdomain = emailDomainParts[0];
  return subdomain;
}

export function referrer() {
  if (typeof document === "undefined") return null;
  const referrer = document.referrer?.trim() || null;
  return referrer ? new URL(referrer).hostname : null;
}

const freeSet = new Set(freeDomains);
const disposableSet = new Set(disposableDomains);

export function isBusinessEmail(email) {
  if (!isEmail(email)) return { ok: false, reason: "Please enter a valid email address." };
  const domain = email.split("@")[1].toLowerCase();

  if (freeSet.has(domain)) return { ok: false, reason: "Please enter your business email address." };
  if (disposableSet.has(domain)) return { ok: false, reason: "Please enter a valid email address." };

  return { ok: true };
}

export function randomPassword(length = 12) {
  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*';
  let password = '';

  for (let i = 0; i < length; i++) {
    password += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return password;
}

export const axiosClient = axios.create({
  baseURL: API_BASE,
  headers: {
    "Content-Type": "application/json"
  },
});

export const onAxiosError = (error, callback) => {
  console.error("Axios Failed: ", error);

  if (axios.isAxiosError(error) && error.code === "ERR_CANCELED") {
    return;
  }

  if (axios.isAxiosError(error)) {
    if (error.code === "ERR_NETWORK") {
      if (!navigator.onLine) {
        Swal.fire({
          title: 'Device Offline',
          text: 'You seem to be offline. Please check your internet and try again.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonText: 'Retry',
        }).then(async (result) => {
          if (result.isConfirmed) {
            callback(result);
            Swal.close();
          }
        });
      } else {
        Swal.fire({
          title: 'Server Unreachable',
          text: 'We’re unable to reach the server right now. Please try again shortly.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonText: 'Retry',
        }).then(async (result) => {
          if (result.isConfirmed) {
            callback(result);
            Swal.close();
          }
        });
      }
    } else if (error.response) {
      const status = error.response.status;
      if (status >= 500) {
        Swal.fire({
          title: '500 Server Error',
          text: 'Server error occurred. Please try again later.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonText: 'Retry',
        }).then(async (result) => {
          if (result.isConfirmed) {
            callback(result);
            Swal.close();
          }
        });
      } else {
        Swal.fire({
          title: 'Request Failed',
          text: 'Request failed. Please check and try again.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonText: 'Retry',
        }).then(async (result) => {
          if (result.isConfirmed) {
            callback(result);
            Swal.close();
          }
        });
      }
    } else {
      Swal.fire({
        title: 'Unexpected Error',
        text: 'Unexpected error. Please try again.',
        icon: 'warning',
        showCancelButton: false,
        confirmButtonText: 'Retry',
      }).then(async (result) => {
        if (result.isConfirmed) {
          callback(result);
          Swal.close();
        }
      });
    }
  } else {
    Swal.fire({
      title: 'Unexpected Error',
      text: 'Unexpected error. Please try again.',
      icon: 'warning',
      showCancelButton: false,
      confirmButtonText: 'Retry',
    }).then(async (result) => {
      if (result.isConfirmed) {
        callback(result);
        Swal.close();
      }
    });
  }
};